import GraphicOptionGroup from './GraphicOptionGroup';

export default GraphicOptionGroup;
